import { useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';
import CSVUpload from '@/components/common/CSVUpload';
import { useToast } from '@/components/common/Toast';
import { ParsedCSVData } from '@/types/upload';

const BookUpload = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleUploadSuccess = (data: ParsedCSVData) => {
    showToast(`アップロード成功: ${data.rows.length}件のデータが登録されました`);
    navigate('/upload-management/new');
  };

  return (
    <div>
      <Breadcrumb />
      <div className="card max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-admin-text mb-2">書籍情報CSVアップロード</h1>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-admin-text mb-2">📋 CSVファイルのフォーマットと注意事項</h2>
          <ul className="text-sm text-admin-textLight space-y-1 list-disc list-inside">
            <li>ファイル形式：CSV形式（.csv）のみ</li>
            <li>ファイルサイズ：10MB以下</li>
            <li>文字コード：UTF-8</li>
            <li>必須項目：JDCN、作品英字名、作品名、著者名など</li>
          </ul>
        </div>

        <CSVUpload
          uploadType="Book"
          onUploadSuccess={handleUploadSuccess}
        />

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate('/upload-management/new')}
            className="px-6 py-2 border border-gray-300 text-admin-text rounded-lg hover:bg-gray-50 transition-colors"
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookUpload;

